import { useTranslation } from 'next-i18next';

import { GeneratedAddress } from '../../../../types/generated';
import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';
import { CardButton } from '../CardButton';

interface Props {
  disabled?: boolean;
  addresses: GeneratedAddress[];
  selectedAddressId?: string;
  onChange: (edit?: boolean) => void;
}

export const ShippingAddressButton = ({
  addresses,
  disabled,
  onChange,
  selectedAddressId,
}: Props) => {
  const { t } = useTranslation(['product']);
  const selectedAddress = addresses.find((a) => a.id === selectedAddressId);
  const [emitter] = useAnalyticsEmitter();

  if (!selectedAddress) {
    return (
      <CardButton
        disabled={disabled}
        icon="chevron"
        onClick={() => {
          emitter(
            addresses.length > 0 ? 'edit address' : 'add address',
            'clicked',
          );
          onChange(addresses.length !== 0);
        }}
      >
        <span className="text-neutral-4">
          {t('drawers.shipping.addButton')}
        </span>
      </CardButton>
    );
  }

  return (
    <CardButton
      disabled={disabled}
      icon="edit"
      onClick={() => {
        emitter(
          addresses.length > 0 ? 'edit address' : 'add address',
          'clicked',
        );
        onChange(true);
      }}
    >
      <div className="flex flex-col">
        <span>
          {selectedAddress.firstName} {selectedAddress.lastName}
        </span>
        <span className="text-neutral-4">
          {[selectedAddress.addressLine1, selectedAddress.addressLine2]
            .filter(Boolean)
            .join(', ')}
        </span>
        <span className="text-neutral-4">
          {selectedAddress.zip?.toLocaleUpperCase()} {selectedAddress.city},{' '}
          {selectedAddress.countryName}
        </span>
      </div>
    </CardButton>
  );
};
